export default __webpack_public_path__ + "static/why-3-edede71395d1b7a6b22ecbebffaae4b2.png";